"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var createOrEdit;
            (function (createOrEdit) {
                class InitArgs {
                    constructor() {
                        this.firstToClaimId = appn.emptyString;
                        this.allToCompleteId = appn.emptyString;
                        this.latLonUser = appn.emptyString;
                        this.modelCanSave = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, true);
                    appn.tasks.initAddressMap({
                        completeAtLot: 'Task_CompleteAtLot',
                        completeAtText: 'Task_CompleteAtText',
                        completeAtCountry: 'Task_CompleteAtCountry',
                        completeAtLat: 'Task_CompleteAtLat',
                        completeAtLon: 'Task_CompleteAtLon'
                    }, _initArgs.latLonUser, _initArgs.modelCanSave);
                    appn.select.init({
                        selector: 'select#iconsToDisplay',
                        isIconSelect: true
                    });
                    if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
                        appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#Task_Name', undefined, undefined, false);
                }
                createOrEdit.init = init;
                function addEvents() {
                    $('select[readonly]').each(function () {
                        $(this).attr('data-original-value', $(this).val());
                        $(this).on('change', function (i) {
                            $(i.target).val($(this).attr('data-original-value'));
                        });
                    });
                    $('#saveLink').on('click', function () {
                        $('form#appnForm').submit();
                    });
                    const originalStatus = $('#Task_Status').find(':selected').text();
                    $('#Task_Status').on('change', function (e) {
                        const currentStatus = $(this).val();
                        if (originalStatus !== currentStatus && originalStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.InProgress]) {
                            let message;
                            if (currentStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.Draft])
                                message = T(`You are about to change the status to Draft. Please note that saved activity data on the user's device may be lost. Additionally this Task will disappear from the Tasks list on the device.<br><br>Hit OK to continue.`);
                            else if (currentStatus === appn.tasks.TaskStatus[appn.tasks.TaskStatus.Completed])
                                message = T(`You are about to change the status to Completed. Please note that saved activity data on the user's device may be lost. Additionally this Task will disappear from the Tasks list on the device.<br><br>Hit OK to continue.`);
                            appn.dialog.confirm({
                                modalColor: 'modal-warning',
                                title: T('Task Status Change'),
                                message: message,
                                buttons: {
                                    confirm: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                callback: function (result) {
                                    if (!result)
                                        $('#Task_Status').val(originalStatus);
                                }
                            });
                        }
                    });
                }
            })(createOrEdit = tasks.createOrEdit || (tasks.createOrEdit = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
